import { Dialog, DialogProps } from "@ariakit/react";

export function ModalDialog(props: Omit<DialogProps, "modal">) {
  return <Dialog {...props} modal />;
}
